/* eslint-disable eqeqeq */
import { _querySourceAuth } from '@/services/authCenter';

interface IProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isPositive?: boolean;
  authParams: { authSource: string; gameCode?: string; queryRole?: boolean };
  //   children: React.ReactNode;
}

export function isSourceAuthQuery(params: { authSource: string; gameCode?: string; queryRole?: boolean }): any {
  return _querySourceAuth({ ...params, typeCls: ['4'] });
}
